<template>
    <div class="container">
        <div class="map-layer-container" v-for="mapLayer of this.mapLayers" v-bind:key="mapLayer.id">
            <div>{{ mapLayerTitle(mapLayer) }}</div>
            <SwitchControl class="switch" v-model="mapLayer.visible" v-if="mapLayer.hideable"></SwitchControl>
        </div>
    </div>
</template>

<script>
import LangUtils from '@/utils/LangUtils'
import SwitchControl from '@/components/ui/control/SwitchControl.vue';

export default {
    name: "MapLayersPanel",

    components: {
        SwitchControl
    },
    
    props: {
        mapLayers: null
    },

    methods: {
        mapLayerTitle(mapLayer) {
            return LangUtils.valueForLanguage(mapLayer.title, this.$i18n.locale);
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-flow: column;
    height: 100%;
    padding: 16px;
}

.map-layer-container {
    display: grid;
    grid-template-columns: auto 50px;
}
</style>